import { getUrl } from 'aws-amplify/storage';
import awsConfig from '../config/aws-config';
import { fetchAuthSession } from 'aws-amplify/auth';

export const getS3ObjectUrl = async (key) => {
  if (!key) return '';
  
  try {
    // Always ensure the key has the public/ prefix
    const keyWithPrefix = key.startsWith('public/') ? key : `public/${key}`;
    
    try {
      // Check if user is authenticated first
      const session = await fetchAuthSession();
      if (!session.tokens?.accessToken) {
        // User is not authenticated, return direct S3 URL
        return `https://${awsConfig.Storage.S3.bucket}.s3.${awsConfig.Storage.S3.region}.amazonaws.com/${keyWithPrefix}`;
      }
      
      // User is authenticated, get signed URL
      const result = await getUrl({
        key: keyWithPrefix,
        options: {
          accessLevel: 'public',
          validateObjectExistence: false
        }
      });
      return result.url.toString();
    } catch (urlError) {
      // If signed URL fails, return direct URL
      return `https://${awsConfig.Storage.S3.bucket}.s3.${awsConfig.Storage.S3.region}.amazonaws.com/${keyWithPrefix}`;
    }
  } catch (error) {
    return '';
  }
};

/**
 * Get S3 URL for audio files
 * Uses getUrl from AWS Amplify to get the proper URL (handles authentication and signed URLs)
 * Note: CloudFront distribution is only for images, so we use getUrl for audio files
 */
export const getS3AudioUrl = async (key) => {
  if (!key) return '';
  
  try {
    // Normalize the key - remove any duplicate 'public/' prefixes
    let cleanKey = key;
    while (cleanKey.startsWith('public/public/')) {
      cleanKey = cleanKey.replace('public/public/', 'public/');
    }
    
    // IMPORTANT: getUrl with accessLevel: 'public' automatically adds 'public/' prefix
    // So we need to REMOVE the prefix if it exists before passing to getUrl
    let keyForGetUrl = cleanKey;
    if (keyForGetUrl.startsWith('public/')) {
      keyForGetUrl = keyForGetUrl.replace('public/', '');
    }
    
    // Use getUrl to get the proper URL (handles authentication and signed URLs)
    // This will return either a CloudFront URL (if configured) or a signed S3 URL
    const result = await getUrl({
      key: keyForGetUrl,
      options: {
        accessLevel: 'public',
        validateObjectExistence: false
      }
    });
    
    return result.url.toString();
  } catch (error) {
    console.error('Error getting audio URL with getUrl:', error);
    // Fallback to direct S3 URL if getUrl fails
    try {
      // Normalize the key again for fallback - keep the public/ prefix for direct S3 URL
      let cleanKey = key;
      while (cleanKey.startsWith('public/public/')) {
        cleanKey = cleanKey.replace('public/public/', 'public/');
      }
      if (!cleanKey.startsWith('public/')) {
        cleanKey = `public/${cleanKey}`;
      }
      return `https://${awsConfig.Storage.S3.bucket}.s3.${awsConfig.Storage.S3.region}.amazonaws.com/${cleanKey}`;
    } catch (fallbackError) {
      return '';
    }
  }
};